package app.bloomey.web.core.data.models

import kotlinx.serialization.Serializable

@Serializable
data class ApiResponse<T>(
    val data: T,
    val message: String? = "",
)

@Serializable
data class LoginRequest(
    val email: String,
    val password: String,
)

@Serializable
data class PageResponse<T>(
    val page: Int,
    val count: Int,
    val items: T,
    val totalPages: Int,
    val totalItems: Int,
)